import angular from 'angular';
import guid from '../../../shared/utils/guid';

angular.module('cloudX').directive('cxTeamPicker', [
  '$filter',
  '$rootScope',
  '$http',
  'appUrls',
  function($filter, $rootScope, $http, appUrls) {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: `<div>
        <tags-input
          ng-model="selected"
          placeholder="{{('Teams'|translate)}}"
          display-property="name"
          key-property="{{keyProperty}}"
          on-tag-added="updateValue()"
          on-tag-removed="updateValue()"
          replace-spaces-with-dashes="false"
          add-from-autocomplete-only="true"
          min-length="1"
          class="bootstrap">
          <auto-complete
            source="getSuggestions($query)"
            load-on-focus="true"
            load-on-empty="true"
            display-property="name"
            min-length="0"></auto-complete>
        </tags-input>
      </div>`,
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;
        $scope.keyProperty = attrs.keyProperty || 'id';
        $scope.showWithoutTeams = attrs.showWithoutTeams || false;

        $scope.selected = [];
        $scope.options = [];
        $scope.loaded = false;
        $scope.tmpValue = null;
        var findOption = function(code) {
          if (code == null || $scope.options.length === 0) return null;
          return $scope.options.find(function(el) {
            return el[$scope.keyProperty] === code;
          });
        };

        $scope.loadTeams = function() {
          return $http.get(`${appUrls.api}/api/Team/MyTeams`).then(({ data }) => {
            $scope.options = data || [];
            if ($scope.showWithoutTeams) {
              $scope.options.unshift({
                id: guid.empty,
                name: $filter('translate')('WithoutTeams'),
                code: 0,
              });
            }
            if ($scope.tmpValue) {
              $scope.selected = $scope.tmpValue.map(x => findOption(x));
              $scope.tmpValue = null;
            }
            $scope.loaded = true;
          });
        };

        $scope.getSuggestions = function(search) {
          if (!$scope.loaded)
            return $scope.loadTeams().then(() => {
              return $filter('filter')($scope.options, search);
            });
          return $filter('filter')($scope.options, search);
        };

        $scope.updateValue = function() {
          ngModel.$setViewValue(
            attrs.objectAsModel ? $scope.selected : $scope.selected.map(x => x[$scope.keyProperty]),
          );
        };

        ngModel.$render = function() {
          var value = ngModel.$viewValue;
          if (value !== null && typeof value !== 'undefined' && angular.isArray(value)) {
            if (!$scope.loaded) {
              $scope.tmpValue = value;
              $scope.loadTeams();
            } else {
              $scope.selected = value.map(x => findOption(x));
            }
          }
        };
      },
    };
  },
]);
